import { Platform } from 'react-native';
import { styles } from './style';
import Theme, { Colors } from '@qnpm/q-theme';
const { responsive: { scale }, layout } = Theme;
const { scenes: { checkBoxColors } } = Colors;
/**
 * 将字符串类型的数字字符串转换为number类型
 * @param value 数字or数字字符串
 */
export function formatNumber(value, needScale) {
    if (typeof value === 'string') {
        return scale(parseFloat(value), needScale);
    }
    return scale(value || 0, needScale);
}
/**
 * 获取复选框的margin
 * @param style 外部定义的属性
 */
export function getCheckBoxMargin(style, needScale) {
    const { marginLeft, marginRight, marginTop, marginBottom, marginHorizontal, marginVertical } = style || {};
    return {
        marginLeft: formatNumber(marginLeft, needScale),
        marginRight: formatNumber(marginRight, needScale),
        marginTop: formatNumber(marginTop, needScale),
        marginBottom: formatNumber(marginBottom, needScale),
        marginHorizontal: formatNumber(marginHorizontal, needScale),
        marginVertical: formatNumber(marginVertical, needScale)
    };
}
/**
 * 获取复选框相关样式
 * @param props 外部属性
 */
export function getCheckBoxColorStyle(props) {
    const { type = 'grayEmpty', size, selected = false, disable = false, needScale = false } = props;
    const selectKey = selected ? 'selected' : 'unselected';
    const styleKey = disable ? 'unavailable' : selectKey;
    // 是否是标签类型
    const isLabel = type === 'side' || type === 'line';
    const typeKey = isLabel ? 'label' : 'base';
    const { wrapper, icon, text } = styles[type][styleKey];
    const { checkBox } = layout;
    const checkboxLayout = needScale ? checkBox.scaled : checkBox.unscaled;
    const { width, height, iconWidth, iconHeight, radius = 0 } = checkboxLayout[typeKey];
    // 标签类型（side or line)的icon有圆角
    const labelIconWrapper = isLabel
        ? {
            borderTopLeftRadius: radius,
            borderBottomRightRadius: radius
        }
        : {};
    // 基础类型下有默认宽高
    const baseSize = isLabel ? {} : { width, height };
    // label样式下有最小宽高
    const labelMin = isLabel ? { minWidth: width, minHeight: height } : {};
    return {
        wrapper: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, wrapper), { borderRadius: radius }), labelMin), baseSize), size),
        icon: Object.assign(Object.assign(Object.assign({}, icon), { width: iconWidth, height: iconHeight }), labelIconWrapper),
        text
    };
}
/**
 * 获取标签类型复选框边框样式
 * @param props 外部属性
 */
export function getCheckBoxBorderStyle(props) {
    const { type, selected = false, disable = false } = props;
    if (!type || type !== 'line') {
        return {};
    }
    const selectKey = selected ? 'selected' : 'unselected';
    const styleKey = disable ? 'unavailable' : selectKey;
    return styles.border[styleKey];
}
/**
 * 标签类型选中状态iconStyle
 */
export function getCheckBoxLableIconStyle() {
    return {
        color: checkBoxColors.icon,
        style: {
            paddingTop: Platform.OS === 'android' ? 0.8 : 0,
            paddingHorizontal: 1
        },
        fontSize: 9
    };
}
/**
 * 获取标签类型内容Wrapper样式
 * @param props 组件属性
 */
export function getLabelContentPadding(props) {
    const { needScale = false, type = 'grayEmpty' } = props;
    // 是否是标签类型
    const isLabel = type === 'side' || type === 'line';
    const typeKey = isLabel ? 'label' : 'base';
    const { checkBox } = layout;
    const checkboxLayout = needScale ? checkBox.scaled : checkBox.unscaled;
    const { wrapperPadding } = checkboxLayout[typeKey];
    return {
        paddingHorizontal: wrapperPadding,
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        height: '100%',
        width: '100%'
    };
}
